<template>
    <div class="container-header">
        <div class="wrap-header">
            <div class="btn-side-header" @click="showSide()">
            </div>
            <div class="logo-header" @click="$router.push('/')"></div>
            <div class="wra-header-btn">
                <button class="btn" @click="logout()">
                    <div class="btn-header logout"></div>
                    <div class="btn-text">로그아웃</div>
                </button>
                <button class="btn" @click="goMypage()">
                    <div class="btn-header my"></div>
                    <div class="btn-text">내 정보</div>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import {mapState} from "vuex";
import {logout} from "@/mixins/Auth";
import AlertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import authMixins from "@/mixins/AuthMixins";
import {setAuthInHeader} from "@/api/request";
import {localStorageKey,newApiURL} from "@/api/config";
import axios from "axios";
export default {
    name: "PageHeader",
    mixins: [AlertMixins, authMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tokenRefreshInProgress: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        // this.handleUserActivity();
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        showSide() {
            EventBus.$emit('showSide');
        },
        logout() {
            this.createConfirm(
                {
                    title: '로그아웃 하시겠습니까?',
                    confirmText: '로그아웃',
                    cancelText: '닫기',
                    customClass: 'alert-common confirm reverse',
                    confirm: () => {
                        logout(this);
                    }
                }
            );
        },

        goMypage() {
            if (this.getAdminType() === this.SUPER_ROLE) {
                this.$router.push('/myinfo/super')
            } else {
                this.$router.push('/myinfo')
            }

        },
        handleUserActivity() {
            if (!this.tokenRefreshInProgress) {
                this.tokenRefreshInProgress = true;
                let token = localStorage.getItem(localStorageKey + 'token');
                if (!token) {
                    return;
                }
                token = token.replace(/^"|"$/g, '');
                let refreshToken = localStorage.getItem(localStorageKey + 'refreshtoken').replace(/^"|"$/g, '');
                this.$api.$auth.refreshToken({refreshToken}).then(res => {
                    let {accessToken} = res.result.data;
                    let {refreshToken} = res.result.data;
                    localStorage.setItem(localStorageKey + 'token', `"${accessToken}"`);
                    localStorage.setItem(localStorageKey + 'refreshtoken', `"${refreshToken}"`);
                    setAuthInHeader(accessToken);
                    this.tokenRefreshInProgress = false;
                }).catch(({response}) => {
                    this.tokenRefreshInProgress = false;
                    if (response.status === 401) {
                        logout(this);
                    }
                });
            }
        },
    },
    watch: {
         '$route.path'(to, from) {
    //   this.handleUserActivity();
    }
    }
}
</script>

<style scoped>

</style>
